export default __webpack_public_path__ + "static/media/problema-07.8c2a0fab.webp";